import axios from "axios";
import { SERVER_URL } from "../socket";

export async function loadProfile(headers) {
  const res = await axios.get(`${SERVER_URL}/api/profile`, { headers });
  return {
    fullName: res.data?.fullName || "",
    mobileNumber: res.data?.mobileNumber || "",
    profileImageUrl: res.data?.profileImageUrl || "",
  };
}

export async function updateProfile(payload, headers) {
  const res = await axios.put(`${SERVER_URL}/api/profile`, payload, { headers });
  return res.data?.user || null;
}

export async function changePassword(payload, headers) {
  await axios.post(`${SERVER_URL}/api/auth/change-password`, payload, { headers });
}
